/* global Stickyfill */

import Component from '../../shared/component';

export default class ContentSidebar extends Component {
  constructor(element) {
    super(...arguments);

    this.$element = $(element);
    Stickyfill.add(this.$element);
  }

  unbindEvents() {
    Stickyfill.remove(this.$element);
  }
}
